import { render, staticRenderFns } from "./SideMenuAvatar.vue?vue&type=template&id=2640ca48&scoped=true&"
import script from "./SideMenuAvatar.vue?vue&type=script&lang=js&"
export * from "./SideMenuAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640ca48",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2640ca48')) {
      api.createRecord('2640ca48', component.options)
    } else {
      api.reload('2640ca48', component.options)
    }
    module.hot.accept("./SideMenuAvatar.vue?vue&type=template&id=2640ca48&scoped=true&", function () {
      api.rerender('2640ca48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SideMenu/SideMenuAvatar.vue"
export default component.exports